import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { RawHTML } from '@wordpress/element';
import useCustomCssBlockProps from '../Common/useCustomCssBlockProps';
const DefaultCssClasses = 'wp-block-leadin-hubspot-meeting-block';
export default function MeetingSaveBlock({ attributes, }) {
    const { url } = attributes;
    const blockProps = useCustomCssBlockProps(DefaultCssClasses);
    if (url) {
        return (_jsx(RawHTML, { ...blockProps, children: `[hubspot url="${url}" type="meeting"]` }));
    }
    return null;
}
